import{
  FETCH_FLEX_META_DATA_LABELS_REQUEST,
  FETCH_FLEX_META_DATA_LABELS_SUCCESS,
  FETCH_FLEX_META_DATA_LABELS_FAILURE
} from "./FlexMetaDataTypes";

const initialState = {
  loading: false,
  labels: [],
  error: ''
};  

const flexMetaDataReducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_FLEX_META_DATA_LABELS_REQUEST: {
        return {
          ...state,
          loading: true
        };
      }
    case FETCH_FLEX_META_DATA_LABELS_SUCCESS: {
      return {
        ...state,
        loading: false,
        labels: action.payload
      };
    }
    case FETCH_FLEX_META_DATA_LABELS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    default:
      return state;
  }
};

export default flexMetaDataReducer;
